import { render } from "./NewCategory.vue?vue&type=template&id=6498447d"
import script from "./NewCategory.vue?vue&type=script&lang=js"
export * from "./NewCategory.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__